import React from 'react';
import { DrawerFooter as BoltDrawerFooter, Button } from '@sainsburys-tech/bolt';
import * as Styled from './DrawerFooter.styles';
import { ATTRIBUTE_TYPE } from '../../config';
import { getColourFabricImage, getLegFinishImage } from '../../helpers';

var ConfirmButton = function ConfirmButton(_ref) {
  var onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(Button, {
    full: true,
    onClick: function onClick() {
      onClose();
    }
  }, "Confirm selection");
};

var DrawerFooter = function DrawerFooter(props) {
  var _selectedProduct$attr, _selectedProduct$attr2, _selectedProduct$attr3, _selectedProduct$attr4, _selectedProduct$attr5, _selectedProduct$attr6;

  var attributeType = props.attributeType,
      selectedProduct = props.selectedProduct,
      onClose = props.onClose; // Selected fabric and colour values

  var selectedFabricValue = selectedProduct === null || selectedProduct === void 0 ? void 0 : (_selectedProduct$attr = selectedProduct.attributes) === null || _selectedProduct$attr === void 0 ? void 0 : (_selectedProduct$attr2 = _selectedProduct$attr.find(function (attr) {
    return attr.type === 'Fabric type';
  })) === null || _selectedProduct$attr2 === void 0 ? void 0 : _selectedProduct$attr2.value;
  var selectedColourValue = selectedProduct === null || selectedProduct === void 0 ? void 0 : (_selectedProduct$attr3 = selectedProduct.attributes) === null || _selectedProduct$attr3 === void 0 ? void 0 : (_selectedProduct$attr4 = _selectedProduct$attr3.find(function (attr) {
    return attr.type === 'Colour';
  })) === null || _selectedProduct$attr4 === void 0 ? void 0 : _selectedProduct$attr4.value;
  var selectedPriceValue = selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.price;
  var selectedColourFabricImage = getColourFabricImage(selectedColourValue, selectedFabricValue); // Selected feet colour values

  var selectedFeetColourValue = selectedProduct === null || selectedProduct === void 0 ? void 0 : (_selectedProduct$attr5 = selectedProduct.attributes) === null || _selectedProduct$attr5 === void 0 ? void 0 : (_selectedProduct$attr6 = _selectedProduct$attr5.find(function (attr) {
    return attr.type === 'Feet colour';
  })) === null || _selectedProduct$attr6 === void 0 ? void 0 : _selectedProduct$attr6.value;
  var selectedLegImage = getLegFinishImage(selectedFeetColourValue, selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.partNumber);

  var getContentByType = function getContentByType(type) {
    switch (type) {
      case ATTRIBUTE_TYPE === null || ATTRIBUTE_TYPE === void 0 ? void 0 : ATTRIBUTE_TYPE.FABRIC_TYPE:
        return /*#__PURE__*/React.createElement(BoltDrawerFooter, null, /*#__PURE__*/React.createElement(Styled.FooterContainer, {
          stretch: true
        }, /*#__PURE__*/React.createElement(Styled.FooterImageWrapper, null, /*#__PURE__*/React.createElement(Styled.FooterImage, {
          src: selectedColourFabricImage.src,
          width: selectedColourFabricImage.width,
          height: selectedColourFabricImage.height,
          alt: selectedColourFabricImage.alt,
          cropParams: selectedColourFabricImage.cropParams
        })), /*#__PURE__*/React.createElement(Styled.FooterTextWrapper, null, /*#__PURE__*/React.createElement(Styled.FooterHeading, {
          "data-test": "drawer-footer-selected-fabric"
        }, selectedFabricValue), /*#__PURE__*/React.createElement("span", {
          "data-test": "drawer-footer-selected-colour"
        }, " ", selectedColourValue)), /*#__PURE__*/React.createElement(Styled.FooterSubHeading, {
          "data-test": "drawer-footer-selected-price"
        }, "\xA3", selectedPriceValue === null || selectedPriceValue === void 0 ? void 0 : selectedPriceValue.toFixed(2))), /*#__PURE__*/React.createElement(ConfirmButton, {
          onClose: onClose
        }));

      case ATTRIBUTE_TYPE === null || ATTRIBUTE_TYPE === void 0 ? void 0 : ATTRIBUTE_TYPE.FEET_COLOUR:
        return /*#__PURE__*/React.createElement(BoltDrawerFooter, null, /*#__PURE__*/React.createElement(Styled.FooterContainer, null, /*#__PURE__*/React.createElement(Styled.FooterImageWrapper, null, /*#__PURE__*/React.createElement(Styled.FooterImage, {
          src: selectedLegImage.src,
          width: selectedLegImage.width,
          alt: selectedLegImage.alt
        })), /*#__PURE__*/React.createElement(Styled.FooterTextWrapper, null, /*#__PURE__*/React.createElement(Styled.FooterHeading, {
          "data-test": "drawer-footer-selected-leg"
        }, selectedFeetColourValue))), /*#__PURE__*/React.createElement(ConfirmButton, {
          onClose: onClose
        }));

      case ATTRIBUTE_TYPE === null || ATTRIBUTE_TYPE === void 0 ? void 0 : ATTRIBUTE_TYPE.FABRIC_INFO:
        return null;

      default:
        return null;
    }
  };

  var footer = getContentByType(attributeType);
  return footer;
};

export default DrawerFooter;